import getDealPaymentTypes from '../../api/deals/getDealPaymentTypes';
import SelectWithFetch from './SelectWithFetch';

const SelectDealPaymentTypes = (props) => {
  return <SelectWithFetch fetch={getDealPaymentTypes} {...props} />;
};

export default SelectDealPaymentTypes;
